import errorInterceptor from './error.interceptor';

export const interceptors = {
  errorInterceptor,
};
